module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/备案图标.d0289dc0.png";